module.exports = __webpack_public_path__ + "images/alternative-page.png";